import * as moment from 'moment';
import { DateConverter } from '../../../core/services/mapper/converters';

export class InfosLastValid {
    static jsonMap = {
        idEntreprise: { key: 'idEntreprise', optional: true },
        dateDerniereMajInventaire: { key: 'dateDerniereMajInventaire', converter: new DateConverter(), optional: true },
        idAuteur: { key: 'idAuteur', optional: true }
    };

    idEntreprise: number;
    dateDerniereMajInventaire: moment.Moment;
    idAuteur: number;
}
